import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: 'Monday', i18nKey: 'common:weekday.monday', value: '0' },
    { label: 'Tuesday', i18nKey: 'common:weekday.tuesday', value: '1' },
    { label: 'Wednesday', i18nKey: 'common:weekday.wednesday', value: '2' },
    { label: 'Thursday', i18nKey: 'common:weekday.thursday', value: '3' },
    { label: 'Friday', i18nKey: 'common:weekday.friday', value: '4' },
    { label: 'Saturday', i18nKey: 'common:weekday.saturday', value: '5' },
    { label: 'Sunday', i18nKey: 'common:weekday.sunday', value: '6' },
]

export default function SelectDay({...props}) {

    const myProps = {
        placeholder: i18n.t('common:filters.selectWeekdays'), label: i18n.t('common:filters.weekdayRequired'),
        firstSelect: true, isClearable: true,
        options: OPTIONS.map(o => ({ ...o, label: i18n.t(o.i18nKey, { defaultValue: o.label }) })),
        icon: {icon: 'calendar-day'}, isMulti: true,
        ...props
    }

    return <SelectSeeker {...myProps} />
}
